<user-navigation></user-navigation>

<div class="container-fluid">
  <div id="top"></div>
    <div class="row no-gutter">
        <div class="col-md-12 col-lg-4 profile-side-bar">
            <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 mb-5 mb-md-0">
                            <div id="page-redirection">
                                <a routerLink="/user/profile">
                                    <img src="../../../../assets/images/arrows/back_arrow.png">
                                    Back to Account
                                </a>
                            </div>
                            <h3 class="display-4 box-title mt-4 mt-md-4">Change Password</h3>
                            <div class="jumbotron p-3 mt-3 alert alert-warning alert-dismissible fade show password-notes mt-4 mt-md-4 mb-5 mb-md-5">
                                <p>Password should contain 8 characters, 1 upper case letter and 1 decimal number</p>
                            </div>
                            <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
                                <!-- Error Message -->
                                <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="error">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="error = !error">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                    {{ errorMsg }}
                                </div>

                                <!-- Success Message -->
                                <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="success">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="success = !success">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                    Password was successfully updated
                                </div>

                                <div class="md-input mt-4">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="password"
                                        formControlName="currentPassword"
                                        [ngClass]="{'error': (submitted && editForm.invalid && f.currentPassword.invalid) || (f.currentPassword.dirty && f.currentPassword.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Current Password</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="password"
                                        formControlName="newPassword"
                                        [ngClass]="{'error': (submitted && editForm.invalid && f.newPassword.invalid) || (f.newPassword.dirty && f.newPassword.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>New Password</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="password"
                                        formControlName="confirmPassword"
                                        [ngClass]="{'error': passwordNotMatch || (submitted && passwordNotMatch) || (submitted && editForm.invalid && f.confirmPassword.invalid) || (f.confirmPassword.dirty && f.confirmPassword.invalid)}"
                                        (keyup)="checkPasswordMisMatch($event)"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Confirm New Password</label>
                                </div>

                                <button type="submit" class="btn btn-primary btn-block btn-submit">
                                    Save
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>

<footer-main></footer-main>
